import './App.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Footer from './components/landing/footer/Footer.js';
import Login from './components/Login/Login.js';




function App() {
   const isAuthenticated = localStorage.getItem("authPassword") === "trump2025";
  return (
    <>
      <Router>
        <Route exact path="/login" render={() => <Login />} />
        <Route
          exact
          path="/"
          render={() =>
            isAuthenticated ? <Landing /> : <Redirect to="/login" />
          }
        />
        <Footer />
      </Router>
    </>
  );
}

export default App;




